import * as m from './messages';
import * as f from './formatters/ZipCode';

export const required = value => (value ? undefined : 'Required.');

export const len = _len => value =>
  value && value.length !== _len ? `Must be ${_len} characters` : undefined;

export const maxLength = max => value =>
  value && value.length > max
    ? `Can't be longer than ${max} characters`
    : undefined;

export const minLength = min => value =>
  value && value.length < min
    ? `Must be at least ${min} characters`
    : undefined;

export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;

export const maxValue = max => value =>
  value && value > max ? `Can't be greater than ${max}` : undefined;

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined;

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined;

export const phoneNumber = value =>
  // Regex is from https://stackoverflow.com/a/29767609/556510
  value &&
  !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value)
    ? 'Invalid phone number'
    : undefined;

export const oneOf = validValues => value =>
  validValues.indexOf(value) === -1 ? 'Invalid.' : undefined;

const len5 = len(5);
export const zipcode = value => number(value) || len5(value);

export const state = states => oneOf(states.map(s => s.value));

export const ukZipcodeRegex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})/;
export const ukZipCode = value =>
  value && !ukZipcodeRegex.test(value) ? 'Invalid postal code' : undefined;

// Israel zip codes are either 5 or 7 digits
export const ilZipCode = value =>
  value && value.length !== 5 && value.length !== 7
    ? m.INVALID_IL_ZIPCODE
    : undefined;

// Canadian postal codes are 6 characters, alternating letter then number, with an optional space in the middle.
export const caZipCodeRegex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/;
export const caZipCode = value => {
  value = f.caZipCodeFormatter(value);
  return !caZipCodeRegex.test(value) ? m.INVALID_ZIPCODE : undefined;
};

export const getZipValidator = (country = 'US') => {
  const countryMap = {
    US: zipcode,
    GB: ukZipCode,
    IL: ilZipCode,
    CA: caZipCode,
  };
  return countryMap[country];
};

// Cybersource gateway has a max length of 35 for any address field
const maxLength35 = maxLength(35);
export const cybersource = value => maxLength35(value);

const minLength6 = minLength(6);
export const password = value => minLength6(value);

export const passwordsMatch = values =>
  values.password !== values.password_confirmation
    ? 'Passwords must match'
    : undefined;



// WEBPACK FOOTER //
// ./app/javascript/common/validators.js